import React from 'react';

import {BenchlingAppSessionStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import Pill, {PillStyle} from 'ui-library/buttons/Pill';

import {STATUS_ICONS} from '../../end-user-page/activity/BenchlingAppSessionStatusCell';

export interface SessionStatusPillProps {
  status: BenchlingAppSessionStatus;
}

export const PILL_STYLES: Record<BenchlingAppSessionStatus, PillStyle> = {
  [BenchlingAppSessionStatus.SUCCEEDED]: PillStyle.SUCCESS,
  [BenchlingAppSessionStatus.RUNNING]: PillStyle.PRIMARY,
  [BenchlingAppSessionStatus.FAILED]: PillStyle.CRITICAL,
  [BenchlingAppSessionStatus.TIMEOUT]: PillStyle.CRITICAL,
  [BenchlingAppSessionStatus.COMPLETED_WITH_WARNINGS]: PillStyle.WARNING,
};

export default function SessionStatusPill(props: SessionStatusPillProps): JSX.Element {
  // override default icon for SUCCEEDED
  const icon =
    props.status === BenchlingAppSessionStatus.SUCCEEDED ? 'check' : STATUS_ICONS[props.status].icon;
  return <Pill icon={icon} text={STATUS_ICONS[props.status].label} style={PILL_STYLES[props.status]} />;
}
